@if (projects) {
  <as-split (dragEnd)="onSidenavDragEnd($event)" class="sidenav-container" direction="horizontal" unit="pixel"
            useTransition="true">
    <as-split-area [size]="sidenavInitialSize" [visible]="sidenavExpanded" class="sidenav" maxSize="600" minSize="150">
      <app-project-list (updated)="onUpdate()" [editable]="true"
                        [projects]="projects" [showDeadline]="false"></app-project-list>
    </as-split-area>
    <as-split-area class="sidenav-content" size="*">
      <div class="toggle-button-container">
        <button (click)="toggleSidenav()" aria-label="Collapse/expand" class="toggle-button" color="primary"
                mat-mini-fab>
          <mat-icon *ngIf="sidenavExpanded">menu_open</mat-icon>
          <mat-icon *ngIf="!sidenavExpanded">menu</mat-icon>
        </button>
      </div>
      <router-outlet></router-outlet>
    </as-split-area>
  </as-split>
} @else {
  <p>Loading projects...</p>
  <!-- TODO prettify loading screens -->
}
